import React from 'react';
import ReactDOM from 'react-dom';
import HomePage from './components/home-page/HomePage';
import NewHomepage from './components/new-home-page/NewHomepage';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/900.css';
import 'styles/global.css';
import '!!style-loader!css-loader?modules=false!animate.css';
import { enforeHttps, onReady } from 'utils/dom';
import { RecoilRoot } from 'recoil';
import './utils/auto-session.ts';
import LocaleProvider from 'components/locale-switcher/LocaleProvider';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ModalProvider from 'mui-modal-provider';
import { PostHogProvider } from 'posthog-js/react';

declare const POSTHOG_API_KEY: string;
declare const POSTHOG_HOST: string;

let SpaceEditorPage: React.FC;

if (ENABLE_SPACE_EDITOR) {
  SpaceEditorPage = React.lazy(
    () =>
      import(
        /* webpackChunkName: "SpaceEditorPage" */ 'components/space-editor-page/SpaceEditorPage'
      ),
  );
}

async function main() {
  if (ENFORCE_HTTPS) {
    const didRedirect = enforeHttps();
    if (didRedirect) return;
  }

  ReactDOM.hydrate(
    <PostHogProvider
      apiKey={POSTHOG_API_KEY}
      options={{
        api_host: POSTHOG_HOST || 'https://us.i.posthog.com',
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
      }}
    >
      <RecoilRoot>
        <LocaleProvider>
          <BrowserRouter>
            <ModalProvider>
              <Switch>
                <Route
                  path="/play/:playCode"
                  render={() => (
                    <React.Suspense fallback={null}>
                      {SpaceEditorPage ? <SpaceEditorPage /> : <HomePage />}
                    </React.Suspense>
                  )}
                />
                <Route path="/jams/:jamId" component={HomePage} />
                <Route path="/new_home_page" component={NewHomepage} />
                <Route component={HomePage} />
              </Switch>
            </ModalProvider>
          </BrowserRouter>
        </LocaleProvider>
      </RecoilRoot>
    </PostHogProvider>,
    document.getElementById('root'),
  );
}

onReady(main);
